module.exports = __webpack_public_path__ + "static/media/csk-tablet-738x57@2x-80.e5540b02.jpg";